import React, { useEffect } from 'react';

import { PageLayout } from '@/components/templates/PageLayout';
import { CmLongLoading, CmScrollBox } from '@/components/uiParts';
import { MenuManagementCategoriesForm } from '@/pages/menu-managements/categories/components/Form';
import { useMenuManagementCategoryForm } from '@/pages/menu-managements/categories/hooks';
import { SearchItemSelectModal } from '@/pages/menu-managements/components/SearchItemSelectModal';
import { MenuManagementNewButtonArea } from '@/pages/menu-managements/components/TopButtonArea';
import { routes } from '@/router';

const MenuManagementCategoriesNewPage: React.FC = (): JSX.Element => {
  const {
    titleJa,
    memo,
    error,
    searchItems,
    selectedItems,
    searchItemName,
    isSearching,
    targetsHeight,
    isLoading,
    handleCreate,
    handleInputName,
    handleInputMemo,
    handleOnDragEnd,
    handleSearchItemNameInput,
    handleAddSelectItems,
    handleDeleteDragItem,
    associateBrandSelectInput,
    initializeNewPageState,
    handleSetMultipleItems,
    handleClickMultipleItemSelect,
    handleCloseCategoryItemModal,
    isCategoryItemModalOpen,
  } = useMenuManagementCategoryForm();

  const isEnabledName = error.titleJa.isTouched && !error.titleJa.isError;
  const isEnabledMemo = !error.memo.isError;

  const isDisabledSubmitButton = [isEnabledName, isEnabledMemo].some(
    (enabled) => !enabled
  );

  useEffect(() => {
    (async () => {
      await initializeNewPageState();
    })();
  }, []);

  return (
    <PageLayout
      title={routes.menuManagementCategoriesNew.title}
      {...{ associateBrandSelectInput }}
    >
      <MenuManagementNewButtonArea
        listUrl="/menu-managements/categories"
        {...{ handleCreate, isDisabledSubmitButton }}
      />
      <CmScrollBox height={`calc(100vh - ${targetsHeight}px)`}>
        <MenuManagementCategoriesForm
          handleClickMultipleItemSelect={handleClickMultipleItemSelect}
          {...{
            titleJa,
            memo,
            handleInputName,
            handleInputMemo,
            error,
            searchItems,
            selectedItems,
            handleOnDragEnd,
            searchItemName,
            handleSearchItemNameInput,
            handleAddSelectItems,
            handleDeleteDragItem,
            isSearching,
          }}
          brandSelectValue={associateBrandSelectInput.value?.value ?? ''}
        />
      </CmScrollBox>
      {isLoading && <CmLongLoading />}
      <SearchItemSelectModal
        title="商品の選択"
        emptyMessage="選択できる商品がありませんでした"
        isLoading={isSearching}
        isOpen={isCategoryItemModalOpen}
        onClose={handleCloseCategoryItemModal}
        selectedItems={selectedItems}
        searchItems={searchItems}
        handleSetMultipleItems={handleSetMultipleItems}
      />
    </PageLayout>
  );
};

export default MenuManagementCategoriesNewPage;
